import { Box } from '@mui/material';
import type { ReactNode, Ref } from 'react';
import { useModalStyles } from '../modal.styles';

interface ModalBodyProps {
  children: ReactNode;
  bodyRef?: Ref<HTMLDivElement>;
  hasFooter?: boolean;
}

const ModalBody = ({ children, bodyRef, hasFooter }: ModalBodyProps) => {
  const { classes, cx } = useModalStyles();

  return (
    <Box ref={bodyRef} className={cx(classes.body, { [classes.bodyWithoutFooter]: !hasFooter })}>
      {children}
    </Box>
  );
};

export default ModalBody;
